// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zA6h","fullView":"styles_fullView__leDq1"};